var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArroww(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Arrow_expand_Line",
    "data-name": "icons/Arrow expand/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.263,
    height: 16.263,
    viewBox: "0 0 16.263 16.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vector_Stroke_",
    "data-name": "vector (Stroke)",
    d: "M10.5,8.678l3.231-3.5a1,1,0,0,0,0-1.357L10.5.322a1,1,0,1,0-1.47,1.357L10.716,3.5H1a1,1,0,1,0,0,2h9.716L9.034,7.322A1,1,0,1,0,10.5,8.678Z",
    transform: "translate(0 9.899) rotate(-45)",
    fill: "#b1b5c3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArroww);
export default __webpack_public_path__ + "static/media/arroww.724fb6f6a452760bea407eda42640d22.svg";
export { ForwardRef as ReactComponent };